import { F0Box } from '@factorialco/f0-react'
import { Skeleton } from '@factorialco/deprecated-design-system'

const ParticipantLoadingRow = () => (
  <F0Box display="flex" flexDirection="row" alignItems="center" justifyContent="between" gap="md">
    <F0Box display="flex" flexDirection="row" alignItems="center" gap="lg">
      <Skeleton width="s24" height="s24" />
      <Skeleton width="s120" height="s16" />
    </F0Box>
    <Skeleton width="s120" height="s32" />
  </F0Box>
)

interface ParticipantLoadingListProps {
  count: number
}

const ParticipantLoadingList = ({ count }: ParticipantLoadingListProps) => (
  <F0Box gap="lg" display="flex" flexDirection="column">
    {Array.from({ length: count }, (_, i) => (
      <ParticipantLoadingRow key={i} />
    ))}
  </F0Box>
)

export default ParticipantLoadingList
